import { render } from "./Game.vue?vue&type=template&id=40ba3c0f&scoped=true"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import "./Game.vue?vue&type=style&index=0&id=40ba3c0f&lang=scss"
import "./Game.vue?vue&type=style&index=1&id=40ba3c0f&lang=scss&scoped=true"

import exportComponent from "/Users/magsin/Projects/sommarfest2022/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ba3c0f"]])

export default __exports__